import React, { Component } from 'react';
import { Button, Header, Segment } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import PropertyForm from './PropertyForm';

class CreateProperty extends Component {
    handleRefreshData = () => {
        this.props.history.push('/imovina/nepokretna-imovina');
    };

    handleClose = () => {
        this.props.history.push('/imovina/nepokretna-imovina');
    };

    render() {
        return (
            <div>
                <Header as="h1">
                    <Header.Content>Dodavanje nove nepokretne imovine</Header.Content>
                </Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>Unesite podatke o novoj nepokretnoj imovini</Header.Content>
                        </Header>
                    </Segment>
                    <Segment>
                        <PropertyForm
                            showOrganizationalUnitDropdown={true}
                            onRefreshData={this.handleRefreshData}
                            onCloseForm={this.handleClose}
                        />
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}

export default withRouter(CreateProperty);



// WEBPACK FOOTER //
// ./src/views/Assets/Property/CreateProperty.js